import { useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { getApiBase } from "../config";

const API_BASE = getApiBase();

export default function ResetPasswordPage() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const token = params.get("token");

  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [error, setError] = useState("");
  const [success, setSuccess] = useState(false);

  const submit = async () => {
    if (!password || password !== confirm) {
      setError("Passwords do not match");
      return;
    }

    const res = await fetch(`${API_BASE}/auth/reset-password`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ token, new_password: password }),
    });

    if (!res.ok) {
      const data = await res.json();
      setError(data.detail || "Reset failed");
      return;
    }

    setSuccess(true);
    setTimeout(() => navigate("/login"), 2000);
  };

  if (!token) {
    return <div className="p-8">Invalid reset link</div>;
  }

  return (
    <div
      className="min-h-screen flex items-center justify-center
                    bg-slate-50 dark:bg-slate-950"
    >
      <div className="w-full max-w-md rounded-xl bg-white dark:bg-slate-900 p-6 shadow-xl">
        <h1 className="text-xl font-bold mb-4">Set a new password</h1>

        {success ? (
          <p className="text-green-600">
            Password reset successful. Redirecting…
          </p>
        ) : (
          <>
            {error && <p className="text-red-600 text-sm mb-2">{error}</p>}

            <input
              type="password"
              placeholder="New password"
              className="w-full mb-3 rounded-lg border px-3 py-2
                         bg-white dark:bg-slate-800
                         border-slate-300 dark:border-slate-700"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />

            <input
              type="password"
              placeholder="Confirm password"
              className="w-full mb-4 rounded-lg border px-3 py-2
                         bg-white dark:bg-slate-800
                         border-slate-300 dark:border-slate-700"
              value={confirm}
              onChange={(e) => setConfirm(e.target.value)}
            />

            <button
              onClick={submit}
              className="w-full py-2 rounded-lg
                         bg-blue-600 text-white"
            >
              Reset password
            </button>
          </>
        )}
      </div>
    </div>
  );
}
